var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFnoimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    stroke: "#D5D7DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_2519_36918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 7.58172 8.58172 4 13 4H37C41.4183 4 45 7.58172 45 12V36C45 40.4183 41.4183 44 37 44H13C8.58172 44 5 40.4183 5 36V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 3.5C41.6944 3.5 45.5 7.30558 45.5 12V36C45.5 40.6944 41.6944 44.5 37 44.5H13C8.30558 44.5 4.5 40.6944 4.5 36V12C4.5 7.30558 8.30558 3.5 13 3.5H37Z",
    stroke: "black",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3848 32.3076V35.9999",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3848 12V15.6923",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6152 32.3076V35.0768",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6152 16.6152V19.3845",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.166 29.748V19.248C23.166 18.4326 23.166 18.025 23.0265 17.7034C22.8404 17.2746 22.4835 16.9339 22.0343 16.7563C21.6974 16.623 21.2702 16.623 20.416 16.623C19.5618 16.623 19.1347 16.623 18.7978 16.7563C18.3485 16.9339 17.9916 17.2746 17.8056 17.7034C17.666 18.025 17.666 18.4326 17.666 19.248V29.748C17.666 30.5634 17.666 30.9711 17.8056 31.2927C17.9916 31.7215 18.3485 32.0622 18.7978 32.2398C19.1347 32.373 19.5618 32.373 20.416 32.373C21.2702 32.373 21.6974 32.373 22.0343 32.2398C22.4835 32.0622 22.8404 31.7215 23.0265 31.2927C23.166 30.9711 23.166 30.5634 23.166 29.748Z",
    stroke: "#111827",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3327 29.748V22.748C32.3327 21.9326 32.3327 21.525 32.1931 21.2034C32.0071 20.7746 31.6502 20.4339 31.2009 20.2563C30.864 20.123 30.4369 20.123 29.5827 20.123C28.7285 20.123 28.3013 20.123 27.9644 20.2563C27.5152 20.4339 27.1583 20.7746 26.9722 21.2034C26.8327 21.525 26.8327 21.9326 26.8327 22.748V29.748C26.8327 30.5634 26.8327 30.9711 26.9722 31.2927C27.1583 31.7215 27.5152 32.0622 27.9644 32.2398C28.3013 32.373 28.7285 32.373 29.5827 32.373C30.4369 32.373 30.864 32.373 31.2009 32.2398C31.6502 32.0622 32.0071 31.7215 32.1931 31.2927C32.3327 30.9711 32.3327 30.5634 32.3327 29.748Z",
    stroke: "#111827",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_2519_36918",
    x: 0,
    y: 1,
    width: 52,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2519_36918"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2519_36918",
    result: "effect2_dropShadow_2519_36918"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2519_36918",
    result: "effect3_dropShadow_2519_36918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2519_36918",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_2519_36918"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnoimage);
export default __webpack_public_path__ + "static/media/fnoimage.88892cd543cf0a0cd37073f236978f66.svg";
export { ForwardRef as ReactComponent };